export default "__VITE_ASSET__D$lQ7jU9__"